<template>
  <div class="rentals-list-body">
    <loader :isShow="isLoading" />
    <div class="prelist">
      <div class="title">Rentals</div>
      <div class="rentals-list-buttons-container">
        <v-popover offset="16" :auto-hide="true" placement="bottom-start">
          <button class="task-cards-filter">
            <span>Properties</span>
            <img class="down-arrow" src="@/assets/DownGreyArrow.svg" />
          </button>
          <template slot="popover">
            <generic-search-check-box-menu
              @property-checked="filterByProperties"
              :checked="selProperties"
              displayProperty="internalName"
              :things="properties"
              class="task-calendar-filter-container"
              searchThing="property"
              :key="'calendar-property-filter'"
            />
          </template>
        </v-popover>
        <Button
          @click="toggleNewRentalMenu(undefined)"
          class="rentals-list-create-new-button"
        >
          New Rental
        </Button>
      </div>
    </div>
    <div v-if="isShowCSVModal">
      <UploadCSVModal @closeModal="closeModal" />
    </div>
    <RentalsHeader @selectionChanged="changeSection" />
    <div class="rentals-list-wrapper">
      <List
        @create="toggleNewRentalMenu()"
        @edit="toggleNewRentalMenu"
        ref="rlist"
        :key="'1'"
        :selectedProperties="selProperties"
        :section="section"
      />
    </div>
    <new-rental-screen
      :selectedRental="selRental"
      @submitted="
        toggleNewRentalMenu()
        refreshList()
      "
      @cancel="toggleNewRentalMenu()"
      v-if="showNewRentalMenu"
    />
  </div>
</template>
<script>
import { Button } from 'ant-design-vue'
import RentalsHeader from '@/components/rentals/RentalsHeader'
import List from '@/components/rentals/List'
import calls from '@/api/calls'
import NewRentalScreen from '@/screens/rentals/NewRentalScreen.vue'
import UploadCSVModal from './UploadCSVModal.vue'
import GenericSearchCheckBoxMenu from '@/components/GenericSearchCheckBoxMenu'
import Loader from '@/components/Loader.vue'

export default {
  name: 'RentalsListScreen',
  components: {
    RentalsHeader,
    List,
    NewRentalScreen,
    UploadCSVModal,
    Button,
    GenericSearchCheckBoxMenu,
    Loader
  },
  data() {
    return {
      section: 1,
      properties: [],
      selProperties: [],
      selProperty: {},
      selRental: null,
      showNewRentalMenu: false,
      listKey: 0,
      isShowCSVModal: false,
      filteredProperties: [],
      isLoading: true
    }
  },
  methods: {
    filterByProperties(value) {
      const existIndex = this.selProperties.findIndex((a) => a === value)
      if (existIndex === -1) {
        this.selProperties.push(value)
      } else {
        this.selProperties.splice(existIndex, 1)
      }
    },
    toggleNewRentalMenu(rental) {
      if (rental) {
        this.selRental = rental
      }
      this.showNewRentalMenu = !this.showNewRentalMenu
      if (this.showNewRentalMenu == false) this.selRental = null
    },
    changeSection(section) {
      this.section = section
    },
    refreshList() {
      this.$refs.rlist.loadRentals()
      this.listKey += 1
    },
    async loadData() {
      this.isLoading = true
      const { data } = await calls.GET('properties')
      this.properties = data
      this.isLoading = false
    },
    showImportModal() {
      this.isShowCSVModal = true
    },
    closeModal() {
      this.isShowCSVModal = false
    },
    filterProperties(id) {
      if (this.filteredProperties.includes(id)) {
        const index = this.filteredProperties.indexOf(id)
        this.filteredProperties.splice(index, 1)
      } else {
        this.filteredProperties.push(id)
      }

      // Filter chores based on selected properties
      let filtChor = []
      for (let i = 0; i < this.chores.length; i++) {
        if (this.filteredProperties.includes(this.chores[i].propertyId))
          filtChor.push(this.chores[i])
      }

      if (this.filteredProperties.length == 0) this.propChores = this.chores
      else this.propChores = filtChor

      // Leave selected chores if they match property
      let ids = []
      for (let i = 0; i < this.propChores.length; i++)
        ids.push(this.propChores[i].uuid)

      for (let i = this.filteredChores.length; i >= 0; i--) {
        let id = this.filteredChores[i]
        if (!ids.includes(id)) {
          this.filteredChores.splice(i, 1)
        }
      }
    }
  },
  async beforeMount() {
    await this.loadData()
  }
}
</script>
<style scoped>
.header-wrapper .right .select-btn {
  position: relative;
  width: 120px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #cbd4dc;
  border-radius: 4px;
  color: #767675;
  font-size: 14px;
  margin-left: 16px;
  text-align: left;
  cursor: pointer;
  padding-left: 16px;
}
.header-wrapper .right .down-arrow {
  position: absolute;
  right: 10px;
  top: 18px;
}

.property-cards-filter {
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 4px;
  width: 120px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  align-items: center;
  color: #767675;
}

.property-cards-filter.selected {
  background: #ffffff;
  border: 1px solid #66b015;
  color: #66b015;
}

.rentals-list-body {
  background-color: #f5f6f8;
  padding: 24px;
  overflow: hidden;
}
.rentals-list-wrapper {
  height: 90%;
  overflow: hidden;
  background-color: white;
  padding-right: 15px;
}

.prelist {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-bottom: 17px;
  height: 56px;
  align-items: center;
}
.title {
  text-align: left;
  letter-spacing: 1px;
  color: #000000;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  line-height: 40px;
}

.task-cards-filter {
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 4px;
  width: 120px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  align-items: center;
  color: #767675;
  padding-left: 16px;
}

.task-cards-filter.selected {
  background: #ffffff;
  border: 1px solid #66b015;
  color: #66b015;
}

.rentals-list-buttons-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.rentals-list-create-new-button {
  text-decoration: none;
  width: 200px;
  height: 42px;
  line-height: 32px;
  color: white;
  background: #66b015;
  border-radius: 4px;
  padding: 2px;
  border: none;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: center;
  margin: 0 5px 0 10px;
}

.rentals-list-create-new-button:hover {
  cursor: pointer;
}

#property-select {
  background: #ffffff;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 4px;
  width: 120px;
  height: 44px;
  color: #767675;
}

#property-select:hover {
  cursor: pointer;
}
</style>
